// eslint-disable-next-line import/no-cycle
import { getApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({}),
	actions: {
		// eslint-disable-next-line no-empty-pattern
		async getCalendarRates({}, days) {
			const response = await getApi(`/api-k3/v2/calculation/calculate-rates?days=${days}`);
			return response;
		},
	},

};
